import{a as e,b as r}from"./chunk-TCEHX7R3.mjs";import"./chunk-ZS6VBONO.mjs";import"./chunk-AQ6EADP3.mjs";export{e as PacketModule,r as createPacketServices};
